import { Box, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { useTranslations } from 'next-intl'

interface DestinationQuickFactsProps {
    facts: { label: string; value: string }[]
}

const DestinationQuickFacts: React.FC<DestinationQuickFactsProps> = ({ facts }) => {
    const t = useTranslations('destinationPage')
    return (
        <Box component="section" sx={{ mb: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1.5 }}>
                <InfoOutlinedIcon sx={{ fontSize: 20, color: 'primary.main' }} />
                <Typography
                    component="h2"
                    variant="h6"
                    sx={{ fontWeight: 600, fontSize: { xs: '1rem', md: '1.1rem' } }}
                >
                    {t('quickFacts')}
                </Typography>
            </Box>
            <Box component="dl" sx={{ m: 0 }}>
                {facts.map(fact => (
                    <Box key={fact.label} sx={{ display: 'flex', py: 0.5, gap: 1 }}>
                        <Typography component="dt" variant="body2" sx={{ color: 'text.secondary', minWidth: 100 }}>
                            {fact.label}
                        </Typography>
                        <Typography component="dd" variant="body2" sx={{ fontWeight: 600, m: 0 }}>
                            {fact.value}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}

export default DestinationQuickFacts
export type { DestinationQuickFactsProps }
